import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class DeposSupplierService extends Service {
    constructor() {
        super();
        this.baseURL = 'product/depository/supplier';
    }

    async mergeDeposSupplier(targetId, sourceId) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL+"/merge/"+ targetId + "/"+ sourceId, {
            crossDomain: true,
            method: 'put',
            headers: { 'Content-Type': 'application/json'},
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response,true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }




}
